import { render, staticRenderFns } from "./Tasklist.vue?vue&type=template&id=558a8ce6&"
import script from "./Tasklist.vue?vue&type=script&lang=js&"
export * from "./Tasklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports